export default {
  title: 'Dashboard',
  description: 'Industrial operations overview',
  widgets: {
    incidentsTrend: 'Incidents Trend',
    actionsByStatus: 'Actions by Status',
    oeeOverview: 'OEE Overview',
    productionLines: 'Production Lines Status',
    criticalAlerts: 'Critical Alerts',
    actionsCompletion: 'Actions Completion Rate',
    incidentsBySeverity: 'Incidents by Severity',
    productionToday: 'Production Today'
  },
  stats: {
    activeIncidents: 'Active Incidents',
    overdueActions: 'Overdue Actions',
    avgOee: 'Average OEE',
    runningLines: 'Running Lines'
  },
  periods: {
    today: 'Today',
    week: 'This Week',
    month: 'This Month',
    year: 'This Year'
  },
  noData: 'No data available'
}
